module.exports = __webpack_public_path__ + "img/cancel.94841eb8.svg";